import { BasicInformation } from '@/pages/client-portal/ui/basic-information/basic-information'

import { cn } from '@/lib/utils'

import { OtherCriticalDates } from './other-critical-dates/other-critical-dates'
import { ProcessingTime } from './processing-time/processing-time'
import { useClientPortalPublicContent } from './use-client-portal-public-content'
import { VisaBulletin } from './visa-bulletin/visa-bulletin'

export const ClientPortalPublicContent = () => {
  const {
    caseData,
    companyData,
    historyData,
    showsProcessingTimeSection,
    showsVisaBulletinSection,
    showsOtherCriticalDates,
  } = useClientPortalPublicContent()

  return (
    <div className={cn('pt-4 lg:pt-[30px]')}>
      <BasicInformation caseData={caseData} companyData={companyData} historyData={historyData} />
      {showsProcessingTimeSection && <ProcessingTime />}
      {showsVisaBulletinSection && <VisaBulletin />}
      {showsOtherCriticalDates && <OtherCriticalDates />}
    </div>
  )
}
